import React from 'react';
import './style.scss';
import { formatNumber } from 'views/utils/format/FormatNumber';
import { formatDate } from 'views/utils/format/FormatDate';

type AccountDataProps = {
  label: string;
  item: string;
  itemType: ItemType;
};

export enum ItemType {
  Normal,
  Amount,
  Date,
}

export const AccountData = (props: AccountDataProps) => {
  const { label, item, itemType } = props;

  const getItemType = (item: string) => {
    switch (itemType) {
      case ItemType.Normal:
        return item;
      case ItemType.Amount:
        return formatNumber(Number(item)) + '円';
      case ItemType.Date:
        return item;
    }
  };

  return (
    <div className="accountData">
      <p className="accountData_label">{label}</p>
      <p className="accountData_item">{getItemType(item)}</p>
    </div>
  );
};
